import { Button, Modal } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC, useState } from 'react';

/**
 * Shown on a draft Estimate whose solar roof was regenerated after it was
 * created: the snapshot now carries the new roof, the panel lines were
 * priced against the old one. Mirrors OutOfDateHeatLossWarning, but says so
 * in words — a bare amber triangle on an estimate row reads as "something is
 * wrong" and nothing more, and the one thing worth knowing here is which
 * roof the prices came from.
 */
const OutOfDateSolarRoofWarning: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="quaternary"
        colour="negative"
        size="xs"
        aria-label="Roof changed since this was priced"
        onClick={() => setIsModalOpen(true)}
      >
        <UntitledIcon name="alert-triangle.3" className="size-4" />
        <span className="text-sm">Roof changed since this was priced</span>
      </Button>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Roof changed"
      >
        <Modal.Body>
          <p>
            The project&apos;s roof design was regenerated after this estimate
            was created. Its panels and prices were worked out against the
            earlier roof. Open the solar designer and create a new estimate to
            use the current one.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Modal.Footer.Actions>
            <Button onClick={() => setIsModalOpen(false)}>Ok</Button>
          </Modal.Footer.Actions>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OutOfDateSolarRoofWarning;
